<div class="content-container">
  <div class="content-area">
    <div class="clr-row">
      <div class="clr-col-lg-4 clr-col-12">
        <div class="card">
          <div class="card-header">
            Производствено нареждане
          </div>
          <div class="card-block">
            <form clrForm [formGroup]="filterForm">
              <clr-input-container>
                <label>Номер</label>
                <input clrInput formControlName="poNumber" autocomplete="off" />
                <clr-control-error *clrIfError="'required'">Грешка</clr-control-error>
              </clr-input-container>

            </form>

            <div *ngIf="poList.length > 0">
              <hr>
              <h4>Има повече от едно ПН с този номер. Моля изберете:</h4>
              <hr>
              <ul class="list compact">
                <li *ngFor="let po of poList" (click)="selectPoFromMultiple(po)">{{po.DocumentType?.TypeName?.BG}} {{po.DocumentNo}} - {{po.DocumentDate | date }}</li>
              </ul>
              <hr>
            </div>

          </div>
          <div class="card-footer">
            <button class="btn btn-primary" type="submit" (click)="loadPoOrders()">Зареди</button>
            <button class="btn" type="button" (click)="resetForm()">Изчисти</button>
          </div>
        </div>
      </div>
      <div class="clr-col-lg-8 clr-col-12">
        <clr-tabs>
          <clr-tab>
            <button clrTabLink>Продуктова структура</button>
            <ng-template [(clrIfActive)]="tehnologieChoose">
              <clr-tab-content>
                <subproducts-tree *ngIf="processRecipe" [recepiesToProcess]="recepiesToProcess" [parent]="this">
                </subproducts-tree>
              </clr-tab-content>
            </ng-template>
          </clr-tab>
          <clr-tab>
            <button clrTabLink>Производствени нареждания</button>
            <ng-template [(clrIfActive)]="poTreeChoose">
              <clr-tab-content>
                <po-tree [wo]="productionOrder"></po-tree>
              </clr-tab-content>
            </ng-template>
          </clr-tab>
          <clr-tab>
            <button clrTabLink>Анализ</button>
            <ng-template [(clrIfActive)]="poAnalysis">
              <clr-tab-content>
                <po-analysis
                [wo]="productionOrder"
                *ngIf="processRecipe"
                [recepiesToProcess]="recepiesToProcess"
                [parent]="this"
                ></po-analysis>
              </clr-tab-content>
            </ng-template>
          </clr-tab>
          <clr-tab>
            <button clrTabLink>Отпечатани печатни форми</button>
            <ng-template [(clrIfActive)]="printsChoose">
              <clr-tab-content>
                <po-prints [wo]="productionOrder"></po-prints>
              </clr-tab-content>
            </ng-template>
          </clr-tab>
          <clr-tab>
            <button clrTabLink>Опис на работни карти</button>
            <ng-template [(clrIfActive)]="poWorkCard">
              <clr-tab-content>
                <po-work-cards [wo]="productionOrder"></po-work-cards>
              </clr-tab-content>
            </ng-template>
          </clr-tab>
        </clr-tabs>
      </div>
    </div>
  </div>
</div>